/** @jsx jsx */
import { jsx, Box, Flex, Text } from 'theme-ui'
import { Button } from 'components/buttons/Button'
import { DefaultBlocks } from 'components/sanity/DefaultBlocks'
import { useMapboxContext } from '../useMapboxContext'
import Link from 'next/link'

const Modal = ({ location, onClose, vantagePoints = false }) => {
  const { map } = useMapboxContext()
  return (
    <Box
      sx={{
        minWidth: ['80%', null, '600px'],
        maxWidth: '800px',
        pt: [2, null, 3],
        pb: [2, null, 3],
        px: [2, null, 3],
        left: '50%',
        transform: 'translateX(-50%)',
        position: 'absolute',
        bottom: 6,
        zIndex: 1000,
        backgroundColor: 'black',
      }}
    >
      {!vantagePoints && (
        <>
          <Button
            variant="smallCopySmallCapsClearReverse"
            sx={{
              display: ['none', null, 'block'],
              position: 'absolute',
              top: ['10px', null, 2],
              right: 3,
            }}
            onClick={() => onClose(map.current)}
          >
            (close)
          </Button>
          <Button
            variant="smallCopySmallCapsClearReverse"
            sx={{
              display: ['block', null, 'none'],
              position: 'absolute',
              top: ['10px', null, 2],
              right: 3,
            }}
            onClick={() => onClose(map.current)}
          >
            (x)
          </Button>
        </>
      )}
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Flex
          sx={{
            maxWidth: 'calc(100% - 120px)',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <Text
            variant="largeHeaderReverse"
            sx={{
              fontSize: ['38px', null, '66px'],
              lineHeight: ['32px', null, '54px'],
            }}
          >
            {!vantagePoints
              ? location?.name || location?.title
              : 'Vantage Points'}
          </Text>
        </Flex>
      </Flex>
      <Box
        sx={{
          flexDirection: 'column',
          pt: 4,
        }}
      >
        {location?.locationCopy && (
          <Box mb={'1em'}>
            <DefaultBlocks blocks={location.locationCopy} reverseColor={true} />
          </Box>
        )}
        {location?.copy && (
          <Box mb={'1em'}>
            <DefaultBlocks blocks={location.copy} reverseColor={true} />
          </Box>
        )}
        {vantagePoints && (
          <Box mb={'1em'}>
            <Text variant="smallCopyReverse" as="p">
              These are the best spots to gather together and view the
              pyrotechnic spectacle of{' '}
              <Link
                href="/event/thence-we-came-forth-to-rebehold-the-stars"
                scroll={false}
                passHref
              >
                <Text
                  as="a"
                  variant="smallCopyReverse"
                  sx={{
                    color: 'inherit',
                    fontSize: 'inherit',
                    lineHeight: 'inherit',
                    textDecoration: 'none',
                    borderBottom: '1px solid currentColor',
                    '::selection': {
                      color: 'black',
                      backgroundColor: 'red',
                    },
                  }}
                >
                  Thence We Came Forth to Rebehold the Stars
                </Text>
              </Link>
              .
            </Text>
          </Box>
        )}
        <Text variant="smallCopyReverse" as="p" sx={{ mb: '1em' }}>
          {location?.number} {location?.street && `${location.street},`}
          {(location?.suburb || location?.postcode) && <br />}
          {location?.suburb}
          {location?.postcode && ` ${location.postcode}`}
        </Text>
        {location?.directionsLink && (
          <Text variant="smallCopyReverse" as="p">
            <Text
              as="a"
              href={location.directionsLink}
              target="_blank"
              variant="smallCopyReverse"
              sx={{
                fontSize: 'inherit',
                lineHeight: 'inherit',
                textDecoration: 'none',
                backgroundImage: `linear-gradient(currentColor 0%, currentColor 100%)`,
                backgroundRepeat: 'repeat-x',
                backgroundPosition: '0 1.15em',
                backgroundSize: '1px 1px',
                '::selection': {
                  color: 'black',
                  backgroundColor: 'red',
                },
              }}
            >
              Directions
            </Text>
          </Text>
        )}
        {location?.locationLink && (
          <Text variant="smallCopyReverse" as="p">
            <Text
              as="a"
              href={location.locationLink}
              target="_blank"
              variant="smallCopyReverse"
              sx={{
                fontSize: 'inherit',
                lineHeight: 'inherit',
                textDecoration: 'none',
                backgroundImage: `linear-gradient(currentColor 0%, currentColor 100%)`,
                backgroundRepeat: 'repeat-x',
                backgroundPosition: '0 1.15em',
                backgroundSize: '1px 1px',
                '::selection': {
                  color: 'black',
                  backgroundColor: 'red',
                },
              }}
            >
              More Info
            </Text>
          </Text>
        )}
      </Box>
    </Box>
  )
}

export { Modal }
